import axiosApi from '@/api/axiosApi';

//修改用户
export const updateSomeInfo = (data) => axiosApi({
  method: 'POST',
  url: '/partner/user/updateSomeInfo',
  data,
});

export const checkCsp = (data) => axiosApi({
  method: 'POST',
  url: '/partner/user/checkCsp',
  data
})

export const getUserInfoByToken = () => axiosApi({
  method: 'GET',
  url: '/partner/user/findRoleByToken',
})

export const getRolesByUser = () => axiosApi({
  method: 'GET',
  url: '/partner/role/getRolesByUser'
})
